var map = {
	"./medal_svip1.png": 1076,
	"./medal_svip2.png": 1077,
	"./medal_svip3.png": 1078,
	"./medal_svip4.png": 1079,
	"./medal_svip5.png": 1080,
	"./medal_vip1.png": 1081,
	"./medal_vip2.png": 1082,
	"./medal_vip3.png": 1083,
	"./medal_vip4.png": 1084,
	"./medal_vip5.png": 1085,
	"./medal_vip6.png": 1086
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1977;